import type { FaireProductEntity } from "../../entity_types/product";

export const p_c8vh57hqjm: FaireProductEntity = {
  token: "p_c8vh57hqjm",
  type: "product",
  name: "5.5in Tall White Glazed Potter's Bud Ceramic Vase",
  brandName: "Jamali Garden",
  imageUrl:
    "https://cdn.faire.com/fastly/4a70a95c81107f545225a679789beac36a3cec81a36892143c458e8b9929e088.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/48d84a4a39fcbf777907dd19b9c0ff4dce00512d3edc6bc517fd52b884aa235b.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
